import { Stack, Typography } from '@mui/material';

import {
  ErrorLoadingPage,
  FilterSummary,
  Loading,
  NoSearchResults,
} from '@hapvida/hapvida-core-components';

import { EmptyResult } from '@components';

import { useBeneficiaryServices } from './hooks/useBeneficiaryServices';
import { BeneficiaryServicesListCard } from './components/BeneficiaryServicesListCard';

export function BeneficiaryServicesLayout() {
  const {
    beneficiariesServiceList: { data: beneficiaries, isError, isLoading },
    isSearchEmpty,
    isResultEmpty,
    refreshBeneficiariesServiceList,
  } = useBeneficiaryServices();

  if (isSearchEmpty) {
    return (
      <EmptyResult
        message="Para visualizar busque pelo
beneficiário no campo de busca."
      />
    );
  }

  if (isError) {
    return <ErrorLoadingPage onReloadClick={refreshBeneficiariesServiceList} />;
  }

  if (isLoading) {
    return (
      <Loading
        padding={8}
        message={
          <>
            Estamos carregando as informações. <br /> Em breve, tudo estará
            pronto para você
          </>
        }
      />
    );
  }

  const beneficiariesLength = beneficiaries?.total ?? 0;

  const filterSummaryLabel = `${beneficiariesLength} ${
    beneficiariesLength === 1 ? 'beneficiário' : 'beneficiários'
  }`;

  return (
    <Stack paddingTop={3} gap={3} paddingBottom={8}>
      <FilterSummary totalLabel={filterSummaryLabel} />

      {isResultEmpty ? (
        <NoSearchResults padding={5} />
      ) : (
        <>
          <Typography variant="subtitle1">Serviços de beneficiário</Typography>
          <BeneficiaryServicesListCard beneficiaries={beneficiaries} />
        </>
      )}
    </Stack>
  );
}
